"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inputReactiveLabel = exports.forms = void 0;
const formhandler_1 = require("../vendor/formhandler");
const forms = () => {
    const flashMessage = new formhandler_1.FlashMessage("#flash-message", 7200);
    const recaptcha_key = document
        .querySelector("meta[name='google_recaptcha_site_key']")
        .getAttribute("content");
    const forms = document.querySelectorAll(".ajax-form");
    for (let form of forms) {
        new formhandler_1.default("#" + form.id, {
            recaptcha: new formhandler_1.GoogleV2(recaptcha_key),
            flashMessage: flashMessage,
            validate: {
                onChange: true,
                onSubmit: true,
            },
            localisation: {
                validationError: "There was a problem validating the form. Please try again.",
                error: "Sorry, there was an error with your submission. Please try again.",
                success: "Thank you for your submission.",
            },
            onSuccess: (form, res) => {
                const formData = new FormData(form);
                const exclude = [
                    "g-recaptcha-response",
                    "token",
                    "_wpnonce",
                    "_email",
                ];
                let formDataObject = {};
                formData.forEach(function (value, key) {
                    if (!exclude.includes(key)) {
                        formDataObject[key] = value;
                    }
                });
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: "HSonFormSubmitted",
                    id: form.id,
                    formData: formDataObject,
                });
                const labels = document.querySelectorAll("label[data-infield]");
                for (let label of labels) {
                    label.dataset.infield = "true";
                }
            },
        });
    }
};
exports.forms = forms;
const inputReactiveLabel = () => {
    const inputs = document.querySelectorAll(".js-infield");
    for (let input of inputs) {
        const updateState = () => {
            const label = document.querySelector(`label[for="${input.id}"]`);
            if (input.value) {
                label.dataset.infield = "false";
            }
            else {
                label.dataset.infield = "true";
            }
        };
        input.addEventListener("change", updateState);
        input.addEventListener("keyup", updateState);
        updateState();
    }
};
exports.inputReactiveLabel = inputReactiveLabel;
